import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import * as profile from "./profile.actions";
import {ProfileState} from "./profile";

const reducer: ActionReducer<ProfileState> = createReducer(
  { profile: null, loading: false, profileLoading: false, modeLoading: false } as ProfileState,
  on(profile.loadProfile, (state: ProfileState, action) => {
    return { ...state, profile: state.profile, loading: true };
  }),
  on(profile.loadProfileSuccess, (state: ProfileState, action) => {
    return { ...state, profile: action.profile, loading: false, profileLoading: false };
  }),
  on(profile.updateProfile, (state: ProfileState, action) => {
    return { ...state, profile: state.profile, profileLoading: true };
  }),
  on(profile.updateProfileSuccess, (state: ProfileState, action) => {
    return { ...state, profile: action.profile, profileLoading: false };
  }),
  on(profile.changeRealConversionsCorrectionMode, (state: ProfileState): ProfileState => {
    return { ...state, modeLoading: true };
  }),
  on(profile.changeRealConversionsCorrectionModeSuccess, (state: ProfileState): ProfileState => {
    return { ...state, modeLoading: false };
  }),
  on(profile.updateProfileAvatar, (state: ProfileState, action) => {
    return { ...state, profileLoading: true };
  })
);

export const profileReducer: ActionReducer<ProfileState> = (state: ProfileState, action: Action) => {
  return reducer(state, action);
};
